import { render } from "./uploaded-files-list.html?vue&type=template&id=7b4afe61&scoped=true&ts=true"
import script from "./uploaded-files-list.ts?vue&type=script&lang=ts"
export * from "./uploaded-files-list.ts?vue&type=script&lang=ts"

import "./uploaded-files-list.scss?vue&type=style&index=0&id=7b4afe61&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Vigiflow\\automation-logs-adminlte-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4afe61"]])

export default __exports__